/* GRAVEYENS PORTAL: animated portal, tabs, request references */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(key, val) { try { if (val === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch (e) { return null; } }

  /* Portal: rotating crimson rings, a glowing core, drifting smoke and particles spiralling inward */
  function portal(canvas) {
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), start = performance.now(), visible = true;
    var parts = [], smoke = [], i;
    for (i = 0; i < 140; i++) parts.push({ a: Math.random() * 6.283, r: 0.25 + Math.random() * 0.75, s: 0.15 + Math.random() * 0.5, z: 0.6 + Math.random() * 1.6 });
    for (i = 0; i < 14; i++) smoke.push({ a: Math.random() * 6.283, r: 0.42 + Math.random() * 0.3, s: (Math.random() - 0.5) * 0.08, k: 0.18 + Math.random() * 0.22 });
    function size() { var b = canvas.getBoundingClientRect(); W = b.width; H = b.height; canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function draw(now) {
      var t = (now - start) / 1000, cx = W / 2, cy = H / 2, R = Math.min(W, H) * 0.36;
      var open = reduced ? 1 : Math.min(t / 1.6, 1), e = 1 - Math.pow(1 - open, 3);
      ctx.clearRect(0, 0, W, H);
      ctx.save(); ctx.translate(cx, cy); ctx.scale(0.55 + 0.45 * e, 0.55 + 0.45 * e); ctx.globalAlpha = e;
      smoke.forEach(function (s) {
        var a = s.a + t * s.s, x = Math.cos(a) * R * s.r * 1.4, y = Math.sin(a) * R * s.r * 1.1;
        var g = ctx.createRadialGradient(x, y, 0, x, y, R * 0.7);
        g.addColorStop(0, 'rgba(40,40,40,' + s.k * 0.55 + ')'); g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g; ctx.fillRect(-R * 2.2, -R * 2.2, R * 4.4, R * 4.4);
      });
      var core = ctx.createRadialGradient(0, 0, 0, 0, 0, R);
      core.addColorStop(0, 'rgba(0,0,0,0.95)'); core.addColorStop(0.62, 'rgba(20,0,0,0.9)'); core.addColorStop(0.86, 'rgba(255,20,20,' + (0.32 + 0.08 * Math.sin(t * 1.4)) + ')'); core.addColorStop(1, 'rgba(255,0,0,0)');
      ctx.fillStyle = core; ctx.beginPath(); ctx.arc(0, 0, R, 0, 6.283); ctx.fill();
      [[1, 0.25, 2.2, 0.9], [1.12, -0.16, 1.2, 0.55], [1.26, 0.09, 0.8, 0.35], [0.82, -0.32, 1, 0.45]].forEach(function (ring, n) {
        var rr = R * ring[0], rot = t * ring[1] + n;
        ctx.lineWidth = ring[2]; ctx.strokeStyle = 'rgba(255,32,32,' + ring[3] + ')'; ctx.shadowColor = 'rgba(255,0,0,0.9)'; ctx.shadowBlur = 14;
        for (var k = 0; k < 3; k++) { ctx.beginPath(); ctx.arc(0, 0, rr, rot + k * 2.094, rot + k * 2.094 + 1.6 - n * 0.2); ctx.stroke(); }
      });
      ctx.shadowBlur = 0;
      parts.forEach(function (p) {
        p.r -= reduced ? 0 : p.s * 0.0025; p.a += reduced ? 0 : p.s * 0.012;
        if (p.r < 0.2) { p.r = 1 + Math.random() * 0.4; p.a = Math.random() * 6.283; }
        var x = Math.cos(p.a) * R * p.r * 1.25, y = Math.sin(p.a) * R * p.r * 1.25, al = Math.min(1, (p.r - 0.2) * 2) * 0.85;
        ctx.fillStyle = 'rgba(255,' + (40 + (p.z * 30 | 0)) + ',40,' + al + ')';
        ctx.beginPath(); ctx.arc(x, y, p.z, 0, 6.283); ctx.fill();
      });
      ctx.restore();
      if (!reduced) { if (visible && !document.hidden) requestAnimationFrame(draw); else setTimeout(function () { requestAnimationFrame(draw); }, 300); }
    }
    size(); window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(canvas);
    requestAnimationFrame(draw);
  }

  function makeRef(prefix) {
    var d = new Date(), pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', out = '', bytes = new Uint8Array(5);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    for (var i = 0; i < 5; i++) out += abc[bytes[i] % abc.length];
    return prefix + '-' + String(d.getFullYear()).slice(2) + pad(d.getMonth() + 1) + pad(d.getDate()) + '-' + out;
  }

  function init(root) {
    if (!root || root.dataset.gpReady) return; root.dataset.gpReady = '1';
    var canvas = root.querySelector('[data-gp-canvas]'); if (canvas) portal(canvas);
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    function show(id, focus) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('aria-controls') === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false'); tab.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls')); if (panel) panel.hidden = !on;
        if (on && focus) tab.focus();
      });
    }
    tabs.forEach(function (tab, n) {
      tab.addEventListener('click', function () { show(tab.getAttribute('aria-controls')); history.replaceState(null, '', '#' + tab.dataset.gpKey); });
      tab.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!k) return; e.preventDefault(); var next = tabs[(n + k + tabs.length) % tabs.length]; show(next.getAttribute('aria-controls'), true);
      });
    });
    /* Each form gets a reference number; after Shopify confirms the submission, show it only in the panel that was submitted */
    var posted = /[?&]contact_posted=true/.test(location.search), hash = location.hash.replace('#', '');
    root.querySelectorAll('[data-gp-form]').forEach(function (wrap) {
      var key = wrap.dataset.gpForm, input = wrap.querySelector('[data-gp-ref-input]'), form = wrap.querySelector('form');
      if (input && !input.value) input.value = makeRef(wrap.dataset.gpPrefix || 'GP');
      if (form) form.addEventListener('submit', function () { if (!form.querySelector('[aria-invalid="true"]')) store('gp-ref-' + key, input ? input.value : ''); });
      var success = wrap.querySelector('[data-gp-success]');
      if (success) {
        var mine = posted && hash === wrap.dataset.gpFormId;
        if (!mine) { success.hidden = true; var f = wrap.querySelector('[data-gp-fields]'); if (f) f.hidden = false; }
        else { var ref = store('gp-ref-' + key), out = success.querySelector('[data-gp-ref-out]'); if (ref && out) { out.textContent = ref; out.hidden = false; var m = success.querySelector('[data-gp-mail]'); if (m) m.href = m.href.replace('REF', encodeURIComponent(ref)); } }
      }
      /* Show the specification fields only for custom parts and architectural models */
      var trigger = wrap.querySelector('[data-gp-custom-trigger]'), extra = wrap.querySelector('[data-gp-custom]');
      if (trigger && extra) {
        var upd = function () { var v = trigger.type === 'checkbox' ? trigger.checked : /custom|architectural/i.test(trigger.value); extra.hidden = !v; };
        trigger.addEventListener('change', upd); upd();
      }
    });
    var keyed = { report: 'gp-report', return: 'gp-return', track: 'gp-track' }, target = keyed[hash];
    if (posted) { var w = root.querySelector('[data-gp-form-id="' + hash + '"]'); if (w) target = w.closest('[role="tabpanel"]').id; }
    show(target || tabs[0].getAttribute('aria-controls'));
    if (posted && target) { var p = document.getElementById(target); if (p) p.scrollIntoView({ block: 'start' }); }
  }
  function boot() { document.querySelectorAll('[data-gp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();